export const DIGITS_CANONICAL_CHART_OF_ACCOUNTS_ID = "59fbabde-46d6-4165-a036-311701f88ff7"
export const DIGITS_CANONICAL_BANK_ACCOUNTS_CATEGORY_ID = "9ce47b9f-93f4-4321-86f1-039e3866faaa"
export const DIGITS_CANONICAL_LEGAL_ENTITY_ID = "d1917535-0350-4350-8350-d19175350350"
export const DIGITS_CANONICAL_USER_ID = "d4f26d49-d957-4b48-9a28-9e4199c13151"
